import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import { Icon } from "@iconify/react/dist/iconify.js";

const StallBooking = () => {
  const [stallInquiry, setStallInquiry] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const GetStallBookingInquiry = async () => {
    try {
      let response = await axios.get(`${BaseUrl}/get-stall-booking-admin`);
      if (response.status === 200) {
        console.log(response.data.data);
        setStallInquiry(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetStallBookingInquiry();
  }, []);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };


  const filteredBooking = stallInquiry?.filter((guards) => {
    const search = searchTerm?.toLowerCase();

    return Object.entries(guards)
      .filter(([key]) =>
        ["name", "mobile_number", "email", "brandName"].includes(key)
      )
      .some(([_, value]) =>
        String(value)?.toLowerCase().includes(search)
      );
  });



  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage] = useState(8);
  const totalItems = stallInquiry?.length || 0;
  const itemsPerPageSafe = itemsPerPage || 1;
  const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  return (
    <MasterLayout>
      <Breadcrumb title="Stall Booking" />

      <div className="col-lg-12">
        <div className="card">
          <div className="card-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
            <h5 className="card-title mb-0">Stall Inquiry Table</h5>

            <form className="navbar-search d-flex align-items-center gap-2">
              <input
                type="text"
                className="bg-base h-40-px w-auto form-control"
                name="search"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>

          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table basic-border-table mb-0">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Brand Name </th>
                    <th>Name</th>
                    <th>mobileNumber</th>
                    <th>Email</th>
                    <th>No Of Stalls</th>
                    <th>Special Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBooking?.slice(startIdx, startIdx + itemsPerPage)?.map((items, index) => {
                    return (
                      <tr key={index}>
                        <td>{formatDate(items.createdAt)}</td>
                        <td>{items.brandName}</td>
                        <td>{items.name}</td>
                        <td>{items.mobile_number}</td>
                        <td>{items.email}</td>
                        <td>{items.noOfStalls}</td>
                        <td>
                          {items.special_requirements
                            ? items.special_requirements
                            : "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {filteredBooking?.length > itemsPerPage &&


              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                <span>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(startIdx + itemsPerPage, filteredBooking?.length)} of{" "}
                  {filteredBooking?.length} entries
                </span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li className="page-item" key={index}>
                      <button
                        className={`page-link ${currentPage === index + 1
                          ? "bg-primary-600 text-white"
                          : "bg-primary-50 text-secondary-light"
                          } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </button>
                  </li>
                </ul>
              </div>}

          </div>
        </div>
        {/* card end */}
      </div>
    </MasterLayout>
  );
};

export default StallBooking;
